import axios from "axios";

import { apiBase } from './apiBase';
export const getHeatmapData = (idx: string | undefined, token: string): Promise<any[]> => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${apiBase()}/hmdata`, {
                params: { idx: idx, token: token },
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else return;
            }
            )
            .catch((err) => {
                reject(err);
            });
    });
};


export const getSectorHeatmapData = (region: string | undefined, token: string): Promise<any[]> => {
    return new Promise(async (resolve, reject) => {
        axios
            .get(`${apiBase()}/sectorhmdata`, {
                params: { region: region, token: token },
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else return;
            }
            )
            .catch((err) => {
                reject(err);
            });
    });
};